import type { TimeLimit, TimeLimitHandler } from './types';
import { TimeLimitType } from './types';
import { RepeatingTimeLimitHandler } from './RepeatingTimeLimitHandler';
import { FixedDatesTimeHandler } from './FixedDatesTimeHandler';
import { FailSafeTimeLimitHandler } from './FailSafeTimeLimit';

export function getTimeLimitHandler(timeLimit: TimeLimit): TimeLimitHandler {
  if (timeLimit.type === TimeLimitType.Repeating) return new RepeatingTimeLimitHandler(timeLimit);
  if (timeLimit.type === TimeLimitType.FixedDates) return new FixedDatesTimeHandler(timeLimit);
  return new FailSafeTimeLimitHandler();
}
